import { TextField as TextFieldWrapper, styled } from '@mui/material';

export const FieldCustom = styled(TextFieldWrapper)({
  '& .MuiInputLabel': {
    color: '#949494',
  },
  '& .MuiFormLabel-root': {
    '&.Mui-error': {
      color: '#949494',
    },
    '&.Mui-focused': {
      color: '#949494',
    },
  },

  '& .MuiInputBase-root:before': {
    borderBottom: '0 !important',
  },
  '& .Mui-error': {
    '& .MuiInputBase-root:before': {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      borderBottomColor: '#FF9F2F',
      '&:hover': {
        '&:not:before': {
          borderBottom: 0,
        },
      },
    },
  },
  '& .MuiInputBase-root:after': {
    borderBottom: '0 !important',
    '&:hover': {
      '&:not:before': {
        borderBottom: 0,
      },
    },
  },
});
